import { render, staticRenderFns } from "./AccountTeam.vue?vue&type=template&id=7298d25c&"
import script from "./AccountTeam.vue?vue&type=script&lang=js&"
export * from "./AccountTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports